import type React from 'react'
import type { SwiperOptions } from 'swiper/types'

import { type Image, ImageSize } from '@frontend/libs/types/media'
import { useEffect } from 'react'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'

import { ProductImage } from './ProductImage'

const swiperOptions: SwiperOptions = {
  modules: [Navigation],
  navigation: true,
  slidesPerView: 1,
}

interface ProductGalleryProps {
  images: Image[]
}

const ProductGalleryHook: React.FC<ProductGalleryProps> = ({ images }) => {
  const swiper = useSwiper()

  useEffect(() => {
    if (images?.length > 0) {
      swiper.slideTo(0, 250)
    }
  }, [images, swiper])

  return <></>
}

export const ProductGallery: React.FC<ProductGalleryProps> = ({ images }) => {
  return (
    <div className="aspect-[3/4] h-full w-full">
      <Swiper {...swiperOptions}>
        {images?.map((image) => (
          <SwiperSlide key={image.id}>
            <ProductImage
              className="select-none object-cover"
              image={image}
              size={ImageSize.Medium}
            />
          </SwiperSlide>
        ))}
        <ProductGalleryHook images={images} />
      </Swiper>
    </div>
  )
}

export default ProductGallery
